import React, { Component } from 'react';
import Layout from "@/Layout";
import CustomerService from '@/CustomerService/UIComponents';
import Router from "next/router";
import ImageWithFallback from "@/ImageWithFallback/";
import { getStaticPropsFromStrapiSEOSetting } from '$DATA/seo';
export async function getStaticProps() {
    return await getStaticPropsFromStrapiSEOSetting('/customer-service'); //參數帶本頁的路徑
}

export default class CustomerServicePage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLogin: false
		};
	}

	componentDidMount() {

	}


	render() {
		const { isLogin } = this.state;
		return (
			<Layout
				title=""
				Keywords=""
				Description=""
				status={8}
				wrapperClassName={'CustomerService'}
				setLoginStatus={(v) => {
					this.setState({ isLogin: v });
				}}
				seoData={this.props.seoData}
			>
				<div className="common-distance-wrap">
					<div className="maintain-header-wrap" style={{ display: 'flex' }}>
						<div className="common-distance" style={{ display: 'flex', alignItems: 'center' }}>
							<div
								className="logo-wrap inline-block"
								onClick={() => {
									Router.push('/');
								}}
							>
								<img
									src="/vn/img/logo/logo.svg"
									width={110}
									height={25}
									alt="fun88"
									fallbackSrc="/vn/img/logo/logo.svg"
								/>
								<div className='line'>|</div>
								<span className='pageTitle'>Trung Tâm Trợ Giúp</span>
							</div>
						</div>
					</div>
				</div>


				<div className="common-distance-wrap">
					<div className="common-distance">
						<CustomerService key={isLogin}></CustomerService>
					</div>
				</div>
			</Layout>
		);
	}
}
